<template>
  <div>
    <el-card shadow="always">
      <el-input size="small" style="width: 280px" placeholder="搜索关键字" clearable v-model.trim="params.keyword" @change="getData()">
        <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
      </el-input>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
      <span style="margin: 0 5px; font-size: 14px">来访日期</span>
      <el-date-picker v-model="params.date_range" type="daterange" value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getData()" style="width: 200px"> </el-date-picker>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="full_name" label="客户姓名" width="100"></el-table-column>
      <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
      <el-table-column prop="recp" label="接待人" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_name ?? scope.row.recp }}</span>
        </template>
      </el-table-column>
      <el-table-column label="登记时间" width="135">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="saveDialog(scope.row)" v-if="$isPerm('customer-visit-rec-save')">修改接待人</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('customer-visit-rec-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <div>
      <el-dialog title="修改接待人" :visible.sync="saveDialogShow" width="300px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
        <el-form size="small" ref="formRef" :model="formData" label-width="60px" style="padding: 20px">
          <el-form-item label="业务员" prop="employee_id">
            <employee-select v-model="formData.employee_id" style="width: 180px"></employee-select>
          </el-form-item>
        </el-form>
        <div class="form-but">
          <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EmployeeSelect from '@/components/employee/select';
export default {
  name: 'customerVisitorReg',
  components: {
    EmployeeSelect
  },
  created() {
    this.getData();
  },
  data() {
    return {
      saveDialogShow: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: '',
        date_range: []
      },
      formData: {
        id: 0,
        employee_id: ''
      },
      selectedIds: []
    };
  },
  methods: {
    //编辑
    saveDialog(row) {
      this.saveDialogShow = true;
      this.formData = {
        id: row.id,
        employee_id: row.employee_id > 0 ? row.employee_id : ''
      };
    },
    // 保存数据
    async saveData() {
      if (!this.formData.id) {
        this.$message.error('请选择记录');
        return;
      }
      if (!this.formData.employee_id) {
        this.$message.error('请选择业务员');
        return;
      }
      this.loading = true;
      await this.$api.customerVisitRec.save(this.formData).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.saveDialogShow = false;
          this.getData();
        }
      });
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length == 0 && !id) {
        this.$message.warning('未选中数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            ids: this.selectedIds.join(',')
          };
          if (id) {
            params.ids = id;
          }
          this.loading = true;
          await this.$api.customerVisitRec.delete(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      if (params.date_range) params.date_range = params.date_range.join(',');
      await this.$api.customerVisitRec.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.saveDialogShow = false;
      this.getData();
    }
  }
};
</script>
<style>
.el-tooltip__popper {
  max-width: 200px !important;
  white-space: pre-line !important;
  line-height: 1.8 !important;
  padding: 10px !important;
}
</style>
